import { Button } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { isDisabledDoneButtonAtom } from '@/atoms/radar';
import { useUpsertRadarTemplate } from '@/hooks/useUpsertRadarTemplate';

export const DoneButton = () => {
  const { t } = useTranslation('general');
  const upsertRadarTemplate = useUpsertRadarTemplate();
  const isDisabled = useAtomValue(isDisabledDoneButtonAtom);

  return (
    <Button onClick={upsertRadarTemplate} variant="primary" disabled={isDisabled}>
      {t('done', { ns: 'general' })}
    </Button>
  );
};
